<app-header></app-header>
<header
  class="masthead text-white text-center d-flex"
  [class.state-full]="paginaInicial"
  [class.state-small]="paginaInicial === false"
  [class.banner-container]="paginaInicial === false">
  <div class="container my-auto">
    <div class="row">
      <div class="col-lg-10 mx-auto">
        <h1 class="text-uppercase" id="titulo">
          <strong>NOSSO BOLÃO DA COPA</strong>
        </h1>
        <hr />
      </div>
      <div class="col-lg-8 mx-auto">
        <p class="text-faded mb-5">
          Este ano é a sexta vez consecutiva que o bolão da copa acontece para trazer o espírito competitivo à família e
          aos seus queridos agregados
        </p>
        <span class="btn btn-primary btn-xl" (click)="scroll(games)" ngsReveal>Mais</span>
      </div>
    </div>
  </div>
</header>
<div class="mid-class" #games>
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
<router-outlet name="dialog"></router-outlet>
